'use client';

import React, { useEffect, useState } from 'react';
import { GoCheckCircleFill  } from 'react-icons/go';
import { PiSealWarningFill, PiWarningOctagonFill, PiWarningCircleFill  } from 'react-icons/pi';
import Swal from 'sweetalert2'

import { alertService, alertType } from '../_services/alert.service';


interface AlertProps {
    message?: string;
    type: typeof alertType[keyof typeof alertType];
    autoClose?: boolean;
    msgtimeout?: number;
    fade?: boolean;
    isShowSwal?: boolean;
}

export default function Alerts(){
    const [alerts, setAlerts] = useState<AlertProps[]>([]);

    useEffect(() => {
        const subscription = alertService.onAlert().subscribe((alert: unknown) => {
            if (!(alert as AlertProps).message) {
                return;
            }

            if ((alert as AlertProps).isShowSwal) {
                Swal.fire({
                    icon: (['success', 'error', 'warning', 'info', 'question'].includes((alert as AlertProps).type) ? (alert as AlertProps).type as 'success' | 'error' | 'warning' | 'info' | 'question' : undefined),
                    title: (alert as AlertProps).type.charAt(0).toUpperCase() + (alert as AlertProps).type.slice(1),
                    html: (alert as AlertProps).message,
                    showCloseButton: false,
                    showConfirmButton: false,
                    allowOutsideClick: true,
                    timer: ((alert as AlertProps).msgtimeout ? (alert as AlertProps).msgtimeout : 3500),
                    customClass: {
                      popup: 'swal-popup',
                    },
                });

                return;
            }

            //only pushes one message every time shows message. but can modify it to keep showing messages
            setAlerts([(alert as AlertProps)]);
    
            // auto close alert in 2.5secs
            if ((alert as AlertProps).autoClose) {
                const istimeoutavble = ((alert as AlertProps).msgtimeout ? (alert as AlertProps).msgtimeout : 3500);
                setTimeout(() => {
                    removeAlert();
                }, istimeoutavble);
            }
        });
      
        function unsub(){
            subscription.unsubscribe();
        }
      
        return unsub;
    });

    //delete alert by clicking
    const removeAlert = () => {
        const selelem = document.querySelector(".alert-popup");
        if(selelem){
            selelem.classList.add("alert-dismissable");
        }

        setTimeout(() => {
            setAlerts([]);
        }, 500);
    }
    //css classes for each message containing alerttypes
    const cssClasses = (alert: AlertProps) => {
        if (!alert) return;

        const classes = ['alert-popup'];

        const alertTypeClass = {
            [alertType.success]: 'alert-popup alert-success',
            [alertType.error]: 'alert-popup alert-danger',
            [alertType.info]: 'alert-popup alert-info',
            [alertType.warning]: 'alert-popup alert-warning'
        }

        classes.push(alertTypeClass[alert.type]);

        if (alert.fade) {
            classes.push('fade');
        }

        return classes.join(' ');
    }

    return (<>
        {alerts.length > 0 && <div className="alert-container">
            {alerts.map((alert, index) =>
                <div key={index} className={cssClasses(alert)}>
                    <div className="alert-icon">
                        {alert.type === alertType.success && <GoCheckCircleFill />}
                        {alert.type === alertType.error && <PiWarningOctagonFill />}
                        {alert.type === alertType.info && <PiSealWarningFill />}
                        {alert.type === alertType.warning && <PiWarningCircleFill />}
                    </div>
                    <label className="close" id={`alert-close-${index}`} onClick={() => removeAlert()}>&times;</label>
                    <span dangerouslySetInnerHTML={{__html: alert.message ?? ''}}></span>
                </div>
            )}
        </div>}
    </>)
}

